import React, { Component } from 'react';
import styled from 'styled-components';
import media from '../../../../theme/media';
import { Icon } from '../../../../theme/assets';
import { Caption } from '../../../../theme/typography';

import iconMozilla from '../../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/mozilla.svg';
import iconCardAudio from '../../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/card-audio.svg';
import iconCardVideo from '../../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/card-video.svg';
import iconImage from '../../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/image.svg';
import iconPrinter from '../../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/printer.svg';
import iconDelete from '../../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/delete.svg';
import iconIrl from '../../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/irl.svg';
import iconWatch from '../../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/watch.svg';
import iconBlog from '../../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/blog.svg';
import iconPaste from '../../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/paste.svg';
import iconPocket from '../../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/pocket.svg';
import iconNotes from '../../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/notes.svg';
import iconReleaseNotes from '../../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/release-notes.svg';
import iconInbox from '../../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/inbox.svg';
import iconPopupBlock from '../../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/popup-block.svg';
import iconWindowNew from '../../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/window-new.svg';
import iconFacebookContainer from '../../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/facebook-container.svg';
import iconAddSearchEngine from '../../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/add-search-engine.svg';
import iconExtensions from '../../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/extensions.svg';
import iconDesktop from '../../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/desktop.svg';
import iconPocketList from '../../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/pocket-list.svg';
import iconSend from '../../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/send.svg';
import iconListen from '../../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/listen.svg';
import iconCommonVoice from '../../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/common-voice.svg';
import iconAudio from '../../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/audio.svg';
import iconAudioMute from '../../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/audio-mute.svg';
import iconSendToDevice from '../../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/send-to-device.svg';
import iconLabs from '../../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/labs.svg';
import iconSecureMixed from '../../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/secure-mixed.svg';
import iconExtensionsUpdate from '../../../../assets/Mozilla/DesignTokens/Icons/assets/svgs/extensions-update.svg';


const PaletteContainer = styled.div`
  width: fit-content;
  width: -moz-fit-content;
  ${media.phone`
    float: none;
  `}
  &.icon-card-audio button.icon-card-audio,
  &.icon-card-video button.icon-card-video,
  &.icon-mozilla button.icon-mozilla,
  &.icon-image button.icon-image,
  &.icon-printer button.icon-printer,
  &.icon-delete button.icon-delete,
  &.icon-irl button.icon-irl,
  &.icon-watch button.icon-watch,
  &.icon-blog button.icon-blog,
  &.icon-paste button.icon-paste,
  &.icon-pocket button.icon-pocket,
  &.icon-notes button.icon-notes,
  &.icon-release-notes button.icon-release-notes,
  &.icon-inbox button.icon-inbox,
  &.icon-popup-block button.icon-popup-block,
  &.icon-window-new button.icon-window-new,
  &.icon-facebook-container button.icon-facebook-container,
  &.icon-add-search-engine button.icon-add-search-engine,
  &.icon-extensions button.icon-extensions,
  &.icon-desktop button.icon-desktop,
  &.icon-pocket-list button.icon-pocket-list,
  &.icon-send button.icon-send,
  &.icon-listen button.icon-listen,
  &.icon-common-voice button.icon-common-voice,
  &.icon-audio button.icon-audio,
  &.icon-audio-mute button.icon-audio-mute,
  &.icon-send-to-device button.icon-send-to-device,
  &.icon-labs button.icon-labs,
  &.icon-secure-mixed button.icon-secure-mixed,
  &.icon-extensions-update button.icon-extensions-update {
      box-shadow: 0 0 0 6px white, 0 0 0 8px #F50900;
  }
`;

const PanelIcon = styled.button`
  background: white;
  display: inline-block;
  width: 32px;
  height: 32px;
  margin: 16px;
  border-radius: 100%;
  
  &.icon-mozilla { background-image: url(${iconMozilla})}
  &.icon-card-audio { background-image: url(${iconCardAudio})}
  &.icon-card-video { background-image: url(${iconCardVideo})}
  &.icon-image { background-image: url(${iconImage})}
  &.icon-printer { background-image: url(${iconPrinter})}
  &.icon-delete { background-image: url(${iconDelete})}
  &.icon-irl { background-image: url(${iconIrl})}
  &.icon-watch { background-image: url(${iconWatch})}
  &.icon-blog { background-image: url(${iconBlog})}
  &.icon-paste { background-image: url(${iconPaste})}
  &.icon-pocket { background-image: url(${iconPocket})}
  &.icon-notes { background-image: url(${iconNotes})}
  &.icon-release-notes { background-image: url(${iconReleaseNotes})}
  &.icon-inbox { background-image: url(${iconInbox})}
  &.icon-popup-block { background-image: url(${iconPopupBlock})}
  &.icon-window-new { background-image: url(${iconWindowNew})}
  &.icon-facebook-container { background-image: url(${iconFacebookContainer})}
  &.icon-add-search-engine { background-image: url(${iconAddSearchEngine})}
  &.icon-extensions { background-image: url(${iconExtensions})}
  &.icon-desktop { background-image: url(${iconDesktop})}
  &.icon-pocket-list { background-image: url(${iconPocketList})}
  &.icon-send { background-image: url(${iconSend})}
  &.icon-listen { background-image: url(${iconListen})}
  &.icon-common-voice { background-image: url(${iconCommonVoice})}
  &.icon-audio { background-image: url(${iconAudio})}
  &.icon-audio-mute { background-image: url(${iconAudioMute})}
  &.icon-send-to-device { background-image: url(${iconSendToDevice})}
  &.icon-labs { background-image: url(${iconLabs})}
  &.icon-secure-mixed { background-image: url(${iconSecureMixed})}
  &.icon-extensions-update { background-image: url(${iconExtensionsUpdate})}
  
  img {
    padding: 4px;
  }
  

  ${media.phone`
    width: 32px;
    height: 32px;
  `}
`;

const ContainerRight = styled.div`
  width: 50%;
  display: inline-block;
  vertical-align: middle;
  ${media.phone`
    width: 100%;
    max-width: 400px;
    margin: 0 auto 4rem auto;
    display: block;
    order: 1;
  `}
`;

const ContainerLeft = styled.div`
  width: 50%;
  display: inline-block;
  vertical-align: middle;
  ${media.phone`
    width: 100%;
    max-width: 400px;
    margin: 0 auto 4rem auto;
    display: block;
    order: 2;
  `}
`;

const Panel = styled.div`
  background: #FFFFFF;
  padding: 48px 32px 32px 32px;
`;

const PanelHeader = styled.div`
  height: 32px;
  margin-bottom: 2rem;
  span {
    text-align: center;
    font-size: 24px;
    font-weight: 600;
    line-height: 32px;
    color: #1E1F21;
  }
  svg {
    float: right;
  }
`;

const PanelImages = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: minmax(100px, 1fr);
  grid-gap: 16px;
  grid-template-areas:
      'a b'
      'c d';
`;

const PanelImg = styled.div`
  span {
    width: 100%;
    display: block;
    text-align: center;
    font-size: 1rem;
  }
  img {
    width: 100%;
    align-self: start;
    &:nth-child(1) { grid-area: a; }
    &:nth-child(2) { grid-area: b; }
    &:nth-child(3) { grid-area: c; }
    &:nth-child(4) { grid-area: d; }
  }
`;

const FlexContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    ${media.phone`
      flex-wrap: wrap;
    `}
`;

class Icons extends Component {
  constructor() {
    super();
    this.state = {
      name: 'Mozilla',
      kebab: 'mozilla',
      shape: 'Rectangle'
    }
  }
  onClickIcon = e => {
    if (e.target.value === 'card-audio') {
      this.setState({
        name: 'Card Audio',
        kebab: 'card-audio',
        shape: 'Circle'
      });
    } else if (e.target.value === 'card-video') {
      this.setState({
        name: 'Card Video',
        kebab: 'card-video',
        shape: 'Circle'
      });
    } else if (e.target.value === 'mozilla') {
      this.setState({
        name: 'Mozilla',
        kebab: 'mozilla',
        shape: 'Rectangle'
      });
    } else if (e.target.value === 'image') {
      this.setState({
        name: 'Image',
        kebab: 'image',
        shape: 'Square'
      });
    } else if (e.target.value === 'printer') {
      this.setState({
        name: 'Printer',
        kebab: 'printer',
        shape: 'Square'
      });
    } else if (e.target.value === 'delete') {
      this.setState({
        name: 'Delete',
        kebab: 'delete',
        shape: 'Rectangle'
      });
    } else if (e.target.value === 'irl') {
      this.setState({
        name: 'IRL Podcast',
        kebab: 'irl',
        shape: 'Square'
      });
    } else if (e.target.value === 'watch') {
      this.setState({
        name: 'Smart Watch',
        kebab: 'watch',
        shape: 'Rectangle'
      });
    } else if (e.target.value === 'blog') {
      this.setState({
        name: 'Blog',
        kebab: 'blog',
        shape: 'Square'
      });
    } else if (e.target.value === 'paste') {
      this.setState({
        name: 'Paste',
        kebab: 'paste',
        shape: 'Square'
      });
    } else if (e.target.value === 'pocket') {
      this.setState({
        name: 'Pocket',
        kebab: 'pocket',
        shape: 'Square'
      });
    } else if (e.target.value === 'notes') {
      this.setState({
        name: 'Notes',
        kebab: 'notes',
        shape: 'Square'
      });
    } else if (e.target.value === 'release-notes') {
      this.setState({
        name: 'Release Notes',
        kebab: 'release-notes',
        shape: 'Square'
      });
    } else if (e.target.value === 'inbox') {
      this.setState({
        name: 'Inbox',
        kebab: 'inbox',
        shape: 'Square'
      });
    } else if (e.target.value === 'popup-block') {
      this.setState({
        name: 'Popup Block',
        kebab: 'popup-block',
        shape: 'Square'
      });
    } else if (e.target.value === 'window-new') {
      this.setState({
        name: 'Window New',
        kebab: 'window-new',
        shape: 'Square'
      });
    } else if (e.target.value === 'facebook-container') {
      this.setState({
        name: 'Facebook Container',
        kebab: 'facebook-container',
        shape: 'Square'
      });
    } else if (e.target.value === 'add-search-engine') {
      this.setState({
        name: 'Add Search Engine',
        kebab: 'add-search-engine',
        shape: 'Square'
      });
    } else if (e.target.value === 'extensions') {
      this.setState({
        name: 'Extensions',
        kebab: 'extensions',
        shape: 'Square'
      });
    } else if (e.target.value === 'desktop') {
      this.setState({
        name: 'Desktop',
        kebab: 'desktop',
        shape: 'Square'
      });
    } else if (e.target.value === 'pocket-list') {
      this.setState({
        name: 'Pocket List',
        kebab: 'pocket-list',
        shape: 'Square'
      });
    } else if (e.target.value === 'send') {
      this.setState({
        name: 'Firefox Send',
        kebab: 'send',
        shape: 'Square'
      });
    } else if (e.target.value === 'listen') {
      this.setState({
        name: 'Firefox Listen',
        kebab: 'listen',
        shape: 'Circle'
      });
    } else if (e.target.value === 'common-voice') {
      this.setState({
        name: 'Common Voice',
        kebab: 'common-voice',
        shape: 'Rectangle'
      });
    } else if (e.target.value === 'audio') {
      this.setState({
        name: 'Audio',
        kebab: 'audio',
        shape: 'Rectangle'
      });
    } else if (e.target.value === 'audio-mute') {
      this.setState({
        name: 'Audio Mute',
        kebab: 'audio-mute',
        shape: 'Rectangle'
      });
    } else if (e.target.value === 'send-to-device') {
      this.setState({
        name: 'Send to Device',
        kebab: 'send-to-device',
        shape: 'Rectangle'
      });
    } else if (e.target.value === 'labs') {
      this.setState({
        name: 'Mozilla Labs',
        kebab: 'labs',
        shape: 'Rectangle'
      });
    } else if (e.target.value === 'secure-mixed') {
      this.setState({
        name: 'Secure Mixed',
        kebab: 'secure-mixed',
        shape: 'Rectangle'
      });
    } else if (e.target.value === 'extensions-update') {
      this.setState({
        name: 'Extensions Update',
        kebab: 'extensions-update',
        shape: 'Rectangle'
      });
    }
  }

  render() {
    return (
      <div>
        <FlexContainer>
          <ContainerLeft>
            <PaletteContainer className={'icon-' + this.state.kebab}>
              <div>
                <PanelIcon className="icon-card-audio"         value={"card-audio"} onClick={e => this.onClickIcon(e, "value")} />
                <PanelIcon className="icon-card-video"         value={"card-video"} onClick={e => this.onClickIcon(e, "value")} />
                <PanelIcon className="icon-mozilla"            value={"mozilla"} onClick={e => this.onClickIcon(e, "value")} />
                <PanelIcon className="icon-image"              value={"image"} onClick={e => this.onClickIcon(e, "value")} />
                <PanelIcon className="icon-printer"            value={"printer"} onClick={e => this.onClickIcon(e, "value")} />
                <PanelIcon className="icon-delete"             value={"delete"} onClick={e => this.onClickIcon(e, "value")} />
                <PanelIcon className="icon-irl"                value={"irl"} onClick={e => this.onClickIcon(e, "value")} />
                <PanelIcon className="icon-watch"              value={"watch"} onClick={e => this.onClickIcon(e, "value")} />
                <PanelIcon className="icon-blog"               value={"blog"} onClick={e => this.onClickIcon(e, "value")} />
                <PanelIcon className="icon-paste"              value={"paste"} onClick={e => this.onClickIcon(e, "value")} />
                <PanelIcon className="icon-pocket"             value={"pocket"} onClick={e => this.onClickIcon(e, "value")} />
                <PanelIcon className="icon-notes"              value={"notes"} onClick={e => this.onClickIcon(e, "value")} />
                <PanelIcon className="icon-release-notes"      value={"release-notes"} onClick={e => this.onClickIcon(e, "value")} />
                <PanelIcon className="icon-inbox"              value={"inbox"} onClick={e => this.onClickIcon(e, "value")} />
                <PanelIcon className="icon-popup-block"        value={"popup-block"} onClick={e => this.onClickIcon(e, "value")} />
                <PanelIcon className="icon-window-new"         value={"window-new"} onClick={e => this.onClickIcon(e, "value")} />
                <PanelIcon className="icon-facebook-container" value={"facebook-container"} onClick={e => this.onClickIcon(e, "value")} />
                <PanelIcon className="icon-add-search-engine"  value={"add-search-engine"} onClick={e => this.onClickIcon(e, "value")} />
                <PanelIcon className="icon-extensions"         value={"extensions"} onClick={e => this.onClickIcon(e, "value")} />
                <PanelIcon className="icon-desktop"            value={"desktop"} onClick={e => this.onClickIcon(e, "value")} />
                <PanelIcon className="icon-pocket-list"        value={"pocket-list"} onClick={e => this.onClickIcon(e, "value")} />
                <PanelIcon className="icon-send"               value={"send"} onClick={e => this.onClickIcon(e, "value")} />
                <PanelIcon className="icon-listen"             value={"listen"} onClick={e => this.onClickIcon(e, "value")} />
                <PanelIcon className="icon-common-voice"       value={"common-voice"} onClick={e => this.onClickIcon(e, "value")} />
                <PanelIcon className="icon-audio"              value={"audio"} onClick={e => this.onClickIcon(e, "value")} />
                <PanelIcon className="icon-audio-mute"         value={"audio-mute"} onClick={e => this.onClickIcon(e, "value")} />
                <PanelIcon className="icon-send-to-device"     value={"send-to-device"} onClick={e => this.onClickIcon(e, "value")} />
                <PanelIcon className="icon-labs"               value={"labs"} onClick={e => this.onClickIcon(e, "value")} />
                <PanelIcon className="icon-secure-mixed"       value={"secure-mixed"} onClick={e => this.onClickIcon(e, "value")} />
                <PanelIcon className="icon-extensions-update"   value={"extensions-update"} onClick={e => this.onClickIcon(e, "value")} />
              </div>
            </PaletteContainer>
          </ContainerLeft>
          <ContainerRight>
            <Panel>
              
              <PanelImages>
                <PanelImg>
                  <img alt="" src={require('../../../../assets/Mozilla/DesignTokens/Icons/assets/' + this.state.kebab + '/icon.svg')} />
                  <span>Icon</span>
                </PanelImg>
                <PanelImg>
                  <img alt="" src={require('../../../../assets/Mozilla/DesignTokens/Icons/assets/' + this.state.kebab + '/stroke.svg')} />
                  <span>2pt Stroke</span>
                </PanelImg>
                <PanelImg>
                  <img alt="" src={require('../../../../assets/Mozilla/DesignTokens/Icons/assets/' + this.state.kebab + '/ends.svg')} />
                  <span>Ends & Joins</span>
                </PanelImg>
                <PanelImg>
                  <img alt="" src={require('../../../../assets/Mozilla/DesignTokens/Icons/assets/' + this.state.kebab + '/shapes.svg')} />
                  <span>{this.state.shape}</span>
                </PanelImg>
              </PanelImages>
            </Panel>
          </ContainerRight>
        </FlexContainer>
        <Caption style={{paddingTop: '2rem'}}><Icon src={require('../../../../icons/touch-red.gif')} alt="icon"/>Hey, you can try this!</Caption>
      </div>
    );
  }
}

export default Icons;



// WEBPACK FOOTER //
// src/assets/Mozilla/DesignTokens/Icons/Icons.js